import { Injectable } from '@angular/core';
import $ from 'jquery';

@Injectable({ providedIn: 'root' })
export class SmilesService {
    replaceImagesToCodes(text: string) {
        const wrapperId = 'temp-wrapper-for-smileys-' + new Date().getTime();

        $('<div>', { id: wrapperId, style: 'display: none' }).appendTo('body');

        const htmlElements = $('#' + wrapperId);

        htmlElements[0].innerHTML = text;

        const smiles = htmlElements.find('.ql-EmojiBlot');

        for (const smile of smiles) {
            const element = smile;

            element.outerHTML = element.innerText;
        }

        const processedText = htmlElements[0].innerHTML;

        htmlElements.remove();

        return processedText;
    }
}
